import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import { APP_TITLE, APP_DESCRIPTION } from "./utils/constants";

ReactDOM.render(
  <React.StrictMode>
    <title>Freshworks Status</title>
    <meta name="description" content={APP_DESCRIPTION} />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
    />
    <meta name="viewport" content="initial-scale=1, width=device-width" />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
